<template>
    <div>
        <template v-if="customerLogo && customerName">
            <router-link to="/your-dashboard">
                <img :src="customerLogo" :alt="customerName + ' | Origo'" :class="{'offset': (session && session.profile)}" />
            </router-link>
        </template>
    </div>
</template>

<script>
export default {
    props: [
        'customerLogo',
        'customerName',
        'session'
    ]
}
</script>
